<div class="spinner">
  <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
  <h3>Loading ...</h3>
</div>
